// extracted by mini-css-extract-plugin
export default {"primary-footer":"footer_primary-footer__eE6jT","footer-items":"footer_footer-items__sMJ54","footerItems":"footer_footerItems__9w3HZ"};